<template>
    <div>
        <h2 class="main-headline">YOUR PROJECT. YOUR VISION.</h2>
        <p class="subheadline">
            Enter text below to visualize what an inscription will look like on your selected brick material.<br/>
            Please note that the image below will not be an exact representation of the final product.
        </p>

        <router-link tag="a" class="back-button" v-bind:to="backRoute">
            Back to Product Guide
        </router-link>

        <template v-for="(product, idx) in catalog">
            <hr v-if="idx > 0" class="product-divider"/>
            <virtual-brick v-bind:product="product"></virtual-brick>
        </template>
    </div>
</template>

<script type="text/jsx">
    import store from '../../store'
    import Brick from './Brick.vue'
    export default {
        name: 'VirtualShowroom',
        metaInfo: {
            title: 'Virtual Brick'
        },
        mixins: [
        ],
        components: {
            'virtual-brick': Brick
        },
        beforeRouteEnter(to, from, next) {
            let productId = to.params.id || '';
            if (productId in store.getters.products) {
                next();
            } else {
                next({name: 'Products'});
            }
        },
        computed: {
            productId: function () {
                return this.$route.params.id;
            },
            catalog: function () {
                if (this.productId in this.$store.getters.products) {
                    return this.$store.getters.products[this.productId];
                }
                return {};
            },
            backRoute: function () {
                return '/product-guide';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Showroom.vue?4e50d455